module.exports = __webpack_public_path__ + "img/premium-cars.070a0343.jpeg";